import script from "./BaseButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseButton.vue?vue&type=script&lang=ts&setup=true"

import "./BaseButton.vue?vue&type=style&index=0&id=07293ef2&lang=scss"

const __exports__ = script;

export default __exports__